import PropTypes from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';

const Loader = (props) => {
    const {height} = props;
    return (
        <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxHeight: "100vh",
            height: `${height === undefined ? '80vh' : height}`
        }}>
            <CircularProgress color=" #002376;" size="2rem" />
        </div>
    )
}

Loader.propTypes = {
    height: PropTypes.string,
};

export default Loader;